import { Bot } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { AgentNodeData } from '@repo/shared-types';

export const AgentNode = ({
  data,
  selected,
}: {
  data: Partial<AgentNodeData> & { label: string };
  selected?: boolean;
}) => {
  const fieldCount = Object.keys(data.outputSchema?.properties ?? {}).length;

  // One compact line rather than a row of chips — the tile has no room, and a
  // node that needs more than this is one you open.
  const subtitle = [
    fieldCount > 0 ? `${fieldCount} field${fieldCount === 1 ? '' : 's'}` : 'no fields',
    data.includeAudio ? 'audio' : null,
    data.persistTo && data.persistTo !== 'none' ? `→ ${data.persistTo}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <NodeShell
      type="agent"
      icon={<Bot size={16} />}
      label={data.label}
      subtitle={subtitle}
      selected={selected}
    />
  );
};
